import React, { useState, useEffect } from 'react';
import GeckoRequest from 'services/gecko-request';
import { renderError } from 'services/gecko-error';
import Loader from 'components/Loader';
import {
  GECKO_CONSTS,
  GeckoField,
  GeckoCardWrapper,
  GeckoCardHeader,
  GeckoCardBody,
} from 'ui';
import CONSTANTS from 'chat-constants';

import './index.scss';

function FeatureToggle({ name, value, onEnable, onDisable }) {
  const [isToggling, setIsToggling] = useState(false);

  const field = {
    key: 'value',
    label: name,
    type: GECKO_CONSTS.FIELD_TYPE_TOGGLE,
  };

  const handleChange = (_, value) => {
    setIsToggling(true);
    const changeFunc = value === true ? onEnable : onDisable;
    return Promise.resolve(changeFunc())
      .catch(renderError)
      .finally(() => setIsToggling(false));
  };

  // Optimistically show the intended value
  const fieldValue = {
    value: isToggling ? !value : value,
  };

  return (
    <Loader isLoading={isToggling}>
      <div className="FeatureToggle">
        <GeckoField values={fieldValue} field={field} handler={handleChange} />
      </div>
    </Loader>
  );
}

function Account({ accountId }) {
  const [account, setAccount] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    GeckoRequest.get(`/admin/account/${accountId}`)
      .then(setAccount)
      .catch(renderError)
      .finally(() => setLoading(false));
  }, [accountId]);

  const getFeatureValue = (featureKey) => {
    return Boolean((account.features || {})[featureKey]);
  };

  // Update our local view of the account to reflect a new feature value
  const setFeature = (featureKey, value) => {
    const newFeatures = Object.assign({}, account.features, {
      [featureKey]: value,
    });
    const newAccount = Object.assign({}, account, { features: newFeatures });
    setAccount(newAccount);
  };

  const enableFeature = async (feature) => {
    try {
      await GeckoRequest.post(`/admin/features/${feature}/enable`, {
        accountId: account.id,
      });
      setFeature(feature, true);
    } catch (error) {
      renderError(error);
    }
  };

  const disableFeature = async (feature) => {
    try {
      await GeckoRequest.post(`/admin/features/${feature}/disable`, {
        accountId: account.id,
      });
      setFeature(feature, false);
    } catch (error) {
      renderError(error);
    }
  };

  return (
    <Loader isLoading={loading}>
      <div className="Account">
        <GeckoCardWrapper>
          <GeckoCardHeader name={account.name} />
          <GeckoCardBody>
            <section>
              <header>Features</header>
              {CONSTANTS.FEATURES.FEATURES.map((feature) => {
                return (
                  <FeatureToggle
                    key={feature}
                    name={feature}
                    value={getFeatureValue(feature)}
                    onEnable={() => enableFeature(feature)}
                    onDisable={() => disableFeature(feature)}
                  />
                );
              })}
              <hr />
            </section>
          </GeckoCardBody>
        </GeckoCardWrapper>
      </div>
    </Loader>
  );
}

export default Account;
